module.exports = __webpack_public_path__ + "static/InfectedPersonsPrefecture_38.dot-d47429755ebc9550be892179ad0d5f5a.svg";